import React from 'react';

export function PriceColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `text-center`;
  };
  return (
    <div className={getLabelCssClasses()}>
      {cellContent.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}₮
    </div>
  );
}
